import React from 'react'
// import classnames from 'classnames'
import { Addresses } from './Addresses'
import { Link } from './Link'
import { Navigation } from './Navigation'
import { logo } from '../images'

const Footer = () => (
  <footer>
    <Link to="/">
      <img src={logo} alt="Dr. Nneka E. Onyezia, Ph.D" width={185} height={22} />
    </Link>
    <Navigation />
    <Addresses />
  </footer>
)

export { Footer }
